// extracted by mini-css-extract-plugin
export default {"empty":"GChartCard-module_empty_c4a3fb52"};